import Button from '@components/Button/Button';
import classNames from 'classnames';

import styles from './SSOLoginButton.module.scss';

interface SSOLoginButtonProps {
  name: string;
  logo: string;
  disabled?: boolean;
  onClick: () => void;
}

export const SSOLoginButton: React.FC<React.PropsWithChildren<SSOLoginButtonProps>> = ({
  name,
  logo,
  onClick,
  disabled = false,
}: SSOLoginButtonProps) => (
  <Button
    size="medium"
    variant="tertiary"
    onClick={onClick}
    disabled={disabled}
    // using id as it has higher precedence with css to override the styles
    // defined in child Button component
    className={classNames(styles['sso-login-button'], styles['precedence-hack'])}
  >
    <div className={styles['button-content']}>
      <img
        src={logo}
        alt={`${name} logo`}
        role="presentation"
        aria-hidden="true"
        className={styles['logo']}
      />
      <span className={styles['text']}>Continue with {name}</span>
    </div>
  </Button>
);
